import React from 'react'
import styled from 'styled-components'
import { media, mediaMax } from 'styles/media'

import ButtonLink from '../../../../components/display/ButtonLink'
import SimpleAnchor from '../../../../components/display/SimpleAnchor'
import RiparideLogo from '../../../../components/icons/RiparideSmallLogo'
import { SectionContainer, SupportTextWrapper } from '../styles'
import IconMap from './IconMap'

const BannerContainer = styled(SectionContainer)`
  margin-top: 0;

  ${mediaMax.xl`
    padding: 0;
  `}

  ${media.xl`
    margin-top: 50px;
  `}
`

const BannerInner = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme?.['-ds-core-50']?.value};
  overflow: hidden;
  position: relative;

  ${media.md`
    flex-direction: row;
  `}

  ${media.xl`
    border-radius: 16px;
  `}
`

const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  order: 2;
  padding: 0 16px 50px 16px;

  ${media.md`
    order: -1;
    width: 55%;
    padding: 50px 20px 50px 30px;
    align-items: flex-start;
  `}

  ${media.xl`
    width: 40%;
    padding: 90px 20px 90px 90px;
  `}

  h1 {
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xxl']?.['font-size'].value};
    font-weight: ${({ theme }) =>
      theme?.['-ds-font-size-xxl']?.['font-weight'].value};
    line-height: 1.3;
    color: ${({ theme }) => theme?.['-ds-core-400']?.value};
    margin-bottom: 20px;

    ${media.md`
      font-size: ${({ theme }) =>
        theme?.['-ds-font-size-xxxl']?.['font-size'].value};
      font-weight: 400;
      line-height: 1.2;
      margin-bottom: 32px;
  `}
  }

  h2 {
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-sm']?.['font-size'].value};
    font-weight: ${({ theme }) =>
      theme?.['-ds-font-size-sm']?.['font-weight'].value};
    margin-bottom: 24px;
    line-height: 1.3;

    ${media.md`
      font-size: ${({ theme }) =>
        theme?.['-ds-font-size-md']?.['font-size'].value};
      font-weight: 300;
  `}
  }
`

const BannerImage = styled.div`
  width: 100%;
  padding: 0 16px;

  ${media.md`
    width: 45%;
    padding: 0;
  `}

  ${media.xl`
    width: 60%;
  `}

  svg {
    height: auto;
    width: 100%;

    ${media.md`
      height: 100%;
      width: auto;
    `}
  }
`

const BannerButton = styled.div`
  display: none;
  align-items: center;
  position: absolute;
  right: 36px;
  bottom: 30px;
  background-color: white;
  border-radius: 70px;
  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.1);
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-sm']?.['font-size']?.value};
  font-weight: 300;
  line-height: 1.3;
  letter-spacing: 0.01em;
  color: ${({ theme }) => theme?.['-ds-core-400']?.value};
  padding: 20px 16px;

  ${media.md`
    display: flex;
  `}

  > svg {
    width: 36px;
  }

  > div {
    width: calc(100% - 36px);
    padding-left: 12px;

    strong {
      font-weight: 400;
    }
  }
`

const BannerFooter = styled(SupportTextWrapper)`
  padding: 16px;

  ${media.md`
    text-align: right;
  `}

  ${media.xl`
    padding-right: 0;
  `}
`

const Header = () => {
  return (
    <BannerContainer>
      <BannerInner>
        <BannerContent>
          <h1>
            Become a <br />
            Riparide Host
          </h1>
          <h2>
            Riparide has arrived in the USA. Join our hundreds of Hosts in{' '}
            <strong>Washington</strong>, <strong>Oregon</strong> and{' '}
            <strong>California</strong> and start attracting like-minded guests.
          </h2>
          <ButtonLink href="/my/listings/new" inline compact>
            GET STARTED
          </ButtonLink>
        </BannerContent>
        <BannerImage>
          <IconMap />
        </BannerImage>
        <BannerButton>
          <RiparideLogo />
          <div>
            <strong>OREGON</strong> &middot; Launching now!
          </div>
        </BannerButton>
      </BannerInner>

      <BannerFooter>
        Need help signing up as a Host?{' '}
        <SimpleAnchor href="mailto:support@riparide.com">
          Contact our Support Team
        </SimpleAnchor>
      </BannerFooter>
    </BannerContainer>
  )
}

export default Header
